const validUnits = ['cm', 'mm', 'in', 'pt', 'em', 'pc', 'px'];

module.exports = function (svg) {
  $(svg).find('[stroke], [stroke-width]')
    .each(checkStrokeUnits);

  return svg;
};

function checkStrokeUnits () {
  handleAttribute.call(this, 'stroke');
  handleAttribute.call(this, 'stroke-width');

  function handleAttribute (attName) {
    const stroke = this.getAttribute(attName);

    if (stroke) {
      const match = stroke.match(/([0-9|.]*)\s*(\w+)\s*$/);

      match &&
      validUnits.indexOf(match[2]) > -1 &&
      this.setAttribute(attName, convertUnitsToPixels(match[1], match[2]));
    }
  }
}

function convertUnitsToPixels (val, unit) {
  const inToCmFactor = 2.54;

  val = parseFloat(val);

  switch (unit) {
    case 'cm':
      return Math.floor4((val * INKIVE.C.DPI) / inToCmFactor);
    case 'mm':
      return convertUnitsToPixels(val / 10, 'cm');
    case 'in':
      return convertUnitsToPixels(val * inToCmFactor, 'cm');
    case 'pt':
      return Math.floor4(val * 1.3281472327365);
    case 'em':
    case 'pc':
      return Math.floor4(val * 16);
  }

  return Math.floor4(val);
}
